import { ga } from 'js/analytics/adapters'
const funnelSteps = {
  'signUp.stats': 'metrics',
  'signUp.pickAccountMethod': 'account-info',
  'subscription.choosePlan': 'choose-plan',
  'subscription.pay': 'payment',
}
// Amplitude's user_start_onboarding is emitted once per step by
// trackAccountFlowStep (both trackers fire together in AccountFlow). This
// tracker keeps only the GA virtual page view so the Amplitude event is not
// fired twice per step.
export const trackSignUpFunnelStep = (step) => {
  ga.virtualPageView(`/signup/${funnelSteps[step]}`)
}
